const phonePattern = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/im;
const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

const validatePhone = (phone) => phonePattern.test(phone);
const validateEmail = (email) => emailPattern.test(email);

export { validatePhone, validateEmail };
